// extracted by mini-css-extract-plugin
export default {"modal":"vyfeiv","title":"Q8dIZu","description":"Kx4lh4","form":"gAuKWO","footer":"EKJT_B","button":"Q6LlEs"};